import React from 'react';
import { getCurrencySymbol } from '../../client/Juno/helpers';
import JunoButton from './common/JunoButton';
import clsx from 'clsx';
import BaseModal from './common/BaseModal';
import { useNavigate } from 'react-router-dom';

function TransactionStatus({
    isOpen = true,
    status = 'success',
    currency,
    amount,
    toAmount,
    toCurrency,
    description,
    onClick,
    buttonText = 'CLOSE',
    transactionType,
}) {
    const navigate = useNavigate();
    const STATUS_CONFIG = {
        success: {
            borderColor: 'var(--color-success)',
            textColor: '!text-success',
            bgColor: '!bg-success',
            title: transactionType ? `${transactionType} CONFIRMED!` : 'Successful!',
            buttonType: 'success',
        },
        error: {
            borderColor: 'var(--color-error)',
            textColor: '!text-error',
            bgColor: '!bg-error',
            title: transactionType ? `${transactionType} FAILED!` : 'ERROR!',
            buttonType: 'error',
        },
        pending: {
            borderColor: 'var(--table-col-title)',
            textColor: '!text-text',
            bgColor: '!bg-primary',
            title: 'PENDING..',
            buttonType: 'primary',
        },
    };

    const config = STATUS_CONFIG[status] || STATUS_CONFIG.success;

    const handleClick = () => {
        onClick();
        if (status === 'pending') {
            navigate('/client/transactions');
        }
    };

    return (
        <BaseModal isOpen={isOpen} onClose={onClick}>
            <div
                className="p-4 text-center border-t-[3px]"
                style={{ borderColor: config.borderColor }}>
                <div className={`${config.textColor} font-semibold text-lg uppercase mb-3`}>
                    {config.title}
                </div>

                {amount && (
                    <div
                        className={clsx(
                            'flex items-center justify-center text-lg !text-text font-semibold mb-3 gap-x-2',
                            toAmount && '!mb-1',
                        )}>
                        {getCurrencySymbol(currency)} <span>{amount}</span>
                        {currency && <span>({currency})</span>}
                    </div>
                )}
                {/* note - toAmount will be used in case of FX and Exchange. */}
                {toAmount && (
                    <div className="!text-text text-center text-base font-medium leading-6 mb-3">
                        {getCurrencySymbol(toCurrency)} <span>{toAmount}</span>
                        {toCurrency && <span>({toCurrency})</span>}
                    </div>
                )}

                <div>
                    <p className="font-medium text-sm uppercase text-balanceCard-manage">
                        {description}
                    </p>
                </div>
            </div>

            <div className="border-t border-input-border bg-[#F4F4F5] dark:bg-[#FFFFFF0A] p-6">
                <JunoButton
                    type={config.buttonType}
                    dataE2e="track-btn"
                    className="font-semibold !rounded-lg"
                    onClick={handleClick}>
                    {buttonText}
                </JunoButton>
            </div>
        </BaseModal>
    );
}

export default TransactionStatus;